module.exports = __webpack_public_path__ + "h5/img/daojishi.8b14c8d3.png";